<template>
  <transition name="fade">
    <div class="loading-screen">
      <img
        id="loading-screen-logo-ios"
        alt="kulturfinder.sh Logo"
        src="@/assets/images/logos/loadingIconIOS.svg"
        v-if="isIOS"
      >
      <img
        id="loading-screen-logo"
        alt="kulturfinder.sh Logo"
        src="@/assets/images/logos/loadingIcon.svg"
        v-else
      >
    </div>
  </transition>
</template>

<script>
export default {
  computed: {
    isIOS() {
      const ua = window.navigator.userAgent
      return !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
    }
  }
}
</script>

<style scoped>
.loading-screen {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1001;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

#loading-screen-logo {
  height: 15%;
  width: auto; /* vh because logo is squared */
}
#loading-screen-logo-ios {
  height: 15%;
  width: auto; /* vh because logo is squared */
  animation: change-size 2s infinite;
}
@keyframes change-size {
  50% {
     transform:scale(1.1);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
